import { useCallback } from "react";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";

import {
	ContractDetailType,
	ContractPeriodType,
} from "../../../../requests_cm/gecoContractsService/types";
import GeneralTabForm from "./GeneralTabForm";
import {
	GeneralTabFormikData,
	generalTabFormikInitialValueMapper,
	formikDataToContractModelMapper,
} from "../../formik/generalTabFormik";
import { If } from "../../../../common/components/If";

export interface GeneralTabProps {
	contract?: ContractDetailType;
	contractPeriod: ContractPeriodType | undefined;
	onSaveDraftContract: (contract: ContractDetailType) => void;
	setHorizonChangeOpen: () => void;
}

const GeneralTab = ({
	contract,
	contractPeriod,
	onSaveDraftContract,
	setHorizonChangeOpen,
}: GeneralTabProps) => {
	const onUpdateGeneralTab = useCallback(
		(data: GeneralTabFormikData) => {
			return onSaveDraftContract(
				formikDataToContractModelMapper(
					data,
					contract as ContractDetailType,
					contractPeriod?.id!
				)
			);
		},
		[contract, contractPeriod?.id]
	);

	return (
		<>
			<If condition={!contract}>
				<CircularProgress
					sx={{ marginTop: "40px" }}
					data-testid="loader"
				/>
			</If>
			<If condition={!!contract}>
				<Formik
					enableReinitialize
					initialValues={generalTabFormikInitialValueMapper(
						contract as ContractDetailType,
						contractPeriod?.id!
					)}
					onSubmit={onUpdateGeneralTab}
				>
					{() => (
						<GeneralTabForm
							setHorizonChangeOpen={setHorizonChangeOpen}
							country={contract?.country ?? ""}
						/>
					)}
				</Formik>
			</If>
		</>
	);
};

export default GeneralTab;
